<span class="material-symbols-rounded">{{ stateIcon }}</span>
<div>{{text}}</div>
<button mat-stroked-button *ngIf="showCloseButton" [mat-dialog-close]>{{'UI.Noconnect.Button.Close|Ok' | translate}}</button>
